import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-feedback-url',
  templateUrl: './new-feedback-url.component.html',
  styleUrls: ['./new-feedback-url.component.scss']
})
export class NewFeedbackUrlComponent implements OnInit {
  current_module: any;
  currentOrigin: string;
  modalImg: any;
  isSkip: any = 0;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.vip_token_transactions();

    this.route.params.subscribe((res: any) => {
      this.current_module = res.id;
      this.currentOrigin = `${window.location.origin}/feedbacks/${this.current_module}`;
      this.get_feedback_manager_url_data(this.current_module);
    });

  }

  open_qr_link() {
    Swal.fire({
      title: 'Warning!',
      text: 'You will be logged out from the website after opening the link.',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Open',
      cancelButtonText: 'Close',
      cancelButtonColor: '#33D4A0',
      confirmButtonColor: '#141631',
      icon: 'warning'
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
        window.open(this.currentOrigin, '_blank');
      }
    });
  }

  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => {
      // this.ending = response.body.ending;
      if (response.body.ending.end == -1) {
        window.location.href = '/new-dashboard/';
      }
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }
  openQrModal(parent) {
    const parentElement = parent.qrcElement.nativeElement.querySelector("img").src;
    this.modalImg = parentElement;
  }

  saveAsImage(parent) {
    // fetches base 64 date from image
    const parentElement = parent.qrcElement.nativeElement.querySelector("img").src;

    // converts base 64 encoded image to blobData
    let blobData = this.convertBase64ToBlob(parentElement);

    // saves as image

    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Qrcode';
    link.click();


  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

  get_feedback_manager_url_data(url) {
    this.auth.get_feedback_manager_url_data(url).subscribe((response: any) => {
      this.isSkip = response.body.isSkip;
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }

  skipFeedback(value) {
    const formData = new FormData();
    formData.append("url", this.current_module);
    formData.append("isSkip", value == true ? '1' : '0');

    this.auth.skipFeedback(formData).subscribe((response: any) => {
      console.log(response)
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }

}
